
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireff10"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireff10"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $b1821fcf34212fca$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["f9fpV","index.0d5a0a63.js","c0vZh","part107.f94afa63.png","lEwX3","real_aperture_100x100.fcc1c84c.png","f0Izm","mug_shot_100x100.52bad7f7.png","eyyUD","icons.6b36839b.svg"]'));

var $4252938372d67376$exports = {};
$4252938372d67376$exports = new URL("part107.f94afa63.png", import.meta.url).toString();


var $73f7bcc9eb4173dc$exports = {};
$73f7bcc9eb4173dc$exports = new URL("real_aperture_100x100.fcc1c84c.png", import.meta.url).toString();


var $09d039b202999e40$exports = {};
$09d039b202999e40$exports = new URL("mug_shot_100x100.52bad7f7.png", import.meta.url).toString();


// icons
// import icons from "../img/icons.svg";
var $77b629c0b49e8bca$exports = {};
$77b629c0b49e8bca$exports = new URL("icons.6b36839b.svg", import.meta.url).toString();


class $2c5f94b49806d192$export$2e2bcd8739ae039 {
    _data;
    _clear() {
        this._parentElement.innerHTML = "";
    }
    /**
   * Render the received data to the DOM
   * @param {Object | Object[]} data The data to be rendered (e.g. recipe)
   * @param {boolean} [render=true] If false, return the generated markup string instead of inserting it into the DOM
   * @returns {undefined | string} A markup string if render=false
   * @this {Object} View instance
   * @author: Sean
   * @todo: finish implementing this
   */ render(render = true) {
        // if (!data || (Array.isArray(data) && data.length === 0))
        //   return this.renderError();
        // this._data = data;
        const markup = this._generateMarkup();
        if (!render) return markup;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    // Change existing data
    update(data) {
        this._data = data;
        const newMarkup = this._generateMarkup();
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const curElements = Array.from(this._parentElement.querySelectorAll("*"));
        newElements.forEach((newEl, i)=>{
            const curEl = curElements[i];
            // Upddates changed text
            if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== "") curEl.textContent = newEl.textContent;
            // Updates changed attributes
            if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach((attr)=>{
                curEl.setAttribute(attr.name, attr.value);
            });
        });
    }
    renderSpinner() {
        const markup = `
    <div class="spinner">
      <svg>
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports)))}#icon-loader"></use>
      </svg>
    </div>`;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderError(message = this._errorMessage) {
        const markup = `
    <div class="error">
      <div>
        <svg>
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports)))}#icon-alert-triangle"></use>
        </svg>
      </div>
      <p>${message}</p>
    </div>
    `;
        this._parentElement.innerHTML = "";
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderMessage(message = this._message) {
        const markup = `
    <div class="message">
          <div>
            <svg>
              <use href="src/img/icons.svg#icon-smile"></use>
            </svg>
          </div>
      <p>${message}</p>
    </div>
    `;
        this._parentElement.innerHTML = "";
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
}


class $9ea1f64088e0df93$var$TabView extends (0, $2c5f94b49806d192$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".operations");
    _errorMessage = "No recipes found for your query. Please try again!";
    _message = "";
    // Pub Sub Pattern
    addHandlerRender(handler) {
        [
            "hashchange",
            "load"
        ].forEach((ev)=>window.addEventListener(ev, handler));
    }
    addHandlerTabs(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const clicked = e.target.closest(".operations__tab");
            if (!clicked) return;
            // Remove active classes
            const tabs = clicked.closest(".operations__tab-container").querySelectorAll(".operations__tab");
            tabs.forEach((tab)=>tab.classList.remove("operations__tab--active"));
            const contents = this.querySelectorAll(".operations__content");
            contents.forEach((content)=>content.classList.remove("operations__content--active"));
            // Activate tab and content
            clicked.classList.add("operations__tab--active");
            document.querySelector(`.operations__content--${clicked.dataset.tab}`).classList.add("operations__content--active");
        });
        handler();
    }
    _generateMarkup() {
        return `
      <div class="operations__tab-container">
        <button
          class="btn operations__tab operations__tab--1 operations__tab--active"
          data-tab="1"
        >
          <span>01</span>Certified
        </button>
        <button class="btn operations__tab operations__tab--2" data-tab="2">
          <span>02</span>Precision
        </button>
        <button class="btn operations__tab operations__tab--3" data-tab="3">
          <span>03</span>Piloting
        </button>
      </div>
      <div
        class="operations__content operations__content--1 operations__content--active"
      >
        <div class="operations__icon">
          <img
            src="${0, (/*@__PURE__*/$parcel$interopDefault($4252938372d67376$exports))}"
            width="100px"
            height="100px"
            alt="pilots"
          />
        </div>
        <h5 class="operations__header">All pilots are Part 107 certified.</h5>
        <p>
          We talk in-depth to identify your needs and your goals that you want
          to achieve with video
        </p>
      </div>

      <div class="operations__content operations__content--2">
        <div class="operations__icon">
          <img
            src="${0, (/*@__PURE__*/$parcel$interopDefault($73f7bcc9eb4173dc$exports))}"
            width="100px"
            height="100px"
            alt="pilots"
          />
        </div>
        <h5 class="operations__header">Precision</h5>
        <p>
          We present a range of video options that align with your specific
          requests, ensuring a perfect fit for your needs
        </p>
      </div>

      <div class="operations__content operations__content--3 circle_img">
        <div class="operations__icon">
          <img
            src="${0, (/*@__PURE__*/$parcel$interopDefault($09d039b202999e40$exports))}"
            width="100px"
            height="100px"
            alt="pilots"
          />
        </div>
        <h5 class="operations__header">Piloting</h5>
        <p>
          From concept to completion, we provide end-to-end coordination to
          ensure your vision is realized seamlessly.
        </p>
      </div>
    `;
    }
    // Tabbed Component
    runScript() {
        const modal = document.querySelector(".modal");
        const overlay = document.querySelector(".overlay");
        const btnCloseModal = document.querySelector(".btn--close-modal");
        const btnsOpenModal = document.querySelectorAll(".btn--show-modal");
        const openModal = function() {
            modal.classList.remove("hidden");
            overlay.classList.remove("hidden");
        };
        const closeModal = function() {
            modal.classList.add("hidden");
            overlay.classList.add("hidden");
        };
        btnsOpenModal.forEach((btns)=>btns.addEventListener("click", openModal));
        btnCloseModal.addEventListener("click", closeModal);
        overlay.addEventListener("click", closeModal);
        document.addEventListener("keydown", function(e) {
            if (e.key === "Escape" && !modal.classList.contains("hidden")) closeModal();
        });
    }
}
var $9ea1f64088e0df93$export$2e2bcd8739ae039 = new $9ea1f64088e0df93$var$TabView();


/**
 * Controls the tab functionality
 * @throws {Error} If tabView is not properly initialized
 */ const $f50bd1f2915ed0f2$var$controlTab = function() {
    try {
        (0, $9ea1f64088e0df93$export$2e2bcd8739ae039).render();
    } catch (error) {
        console.error("Error rendering tab view:", error);
        (0, $9ea1f64088e0df93$export$2e2bcd8739ae039).renderError("Failed to render tab view. Please refresh the page.");
    }
};
/**
 * Initializes the application
 * Sets up event handlers and initial render
 */ const $f50bd1f2915ed0f2$var$init = function() {
    try {
        // Set up event handlers
        (0, $9ea1f64088e0df93$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlTab);
        (0, $9ea1f64088e0df93$export$2e2bcd8739ae039).addHandlerTabs($f50bd1f2915ed0f2$var$controlTab);
        // Initial render
        $f50bd1f2915ed0f2$var$controlTab();
    } catch (error) {
        console.error("Failed to initialize application:", error);
        (0, $9ea1f64088e0df93$export$2e2bcd8739ae039).renderError("Failed to initialize application. Please refresh the page.");
    }
};
// Initialize the application
document.addEventListener("DOMContentLoaded", $f50bd1f2915ed0f2$var$init);


//# sourceMappingURL=index.0d5a0a63.js.map
